import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from './components/layout/DashboardLayout';
import DashboardPage from './pages/DashboardPage';
import UsuariosPage from './pages/configuracion/UsuariosPage';
import AddUserPage from './pages/users/AddUserPage';
import EditUserPage from './pages/users/EditUserPage';
import MantenimientoPage from './pages/configuracion/MantenimientoPage';
import ProcesosPage from './pages/configuracion/ProcesosPage';
import VersionesAppPage from './pages/configuracion/VersionesAppPage';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import AiImagePage from './pages/AiImagePage';
import PromotionsPage from './pages/PromotionsPage';
import NewsPage from './pages/NewsPage';
import NotificationsPage from './pages/NotificationsPage';
import ClientsPage from './pages/ClientsPage';
import PointsPage from './pages/PointsPage';
import ClientPointsPage from './pages/ClientPointsPage';
import ConsumersPage from './pages/ConsumersPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import RootProtectedRoute from './components/auth/RootProtectedRoute';
import { useAuth } from './contexts/AuthContext';
import ProductsPage from './pages/ProductsPage';
import { useMaintenance } from './contexts/MaintenanceContext';
import MapPage from './pages/MapPage';
import GISPage from './pages/wip/GISPage';

const AppRoutes: React.FC = () => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>; // You can replace this with a loading spinner
  }

  return (
    <Routes>
      <Route path="/login" element={!currentUser ? <LoginPage /> : <Navigate to="/" replace />} />
      <Route path="/forgot-password" element={!currentUser ? <ForgotPasswordPage /> : <Navigate to="/" replace />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="clientes">
          <Route index element={<ClientsPage />} />
          <Route path="puntos-clientes" element={<ClientPointsPage />} />
          <Route path="puntos" element={<PointsPage />} />
        </Route>
        <Route path="ai-image" element={<AiImagePage />} />
        <Route path="promociones" element={<PromotionsPage />} />
        <Route path="novedades" element={<NewsPage />} />
        <Route path="notificaciones" element={<NotificationsPage />} />
        <Route path="configuracion">
          <Route index element={<RootProtectedRoute><Navigate to="usuarios" replace /></RootProtectedRoute>} />
          <Route path="usuarios" element={<RootProtectedRoute><UsuariosPage /></RootProtectedRoute>} />
          <Route path="mantenimiento" element={<RootProtectedRoute><MantenimientoPage /></RootProtectedRoute>} />
          <Route path="procesos" element={<RootProtectedRoute><ProcesosPage /></RootProtectedRoute>} />
          <Route path="versiones-app" element={<RootProtectedRoute><VersionesAppPage /></RootProtectedRoute>} />
        </Route>
        <Route path="users">
          <Route path="new" element={<AddUserPage />} />
          <Route path="edit/:userId" element={<EditUserPage />} />
        </Route>
        {/* <Route path="productos" element={<ProductsPage />} /> */}
        <Route path="consumidores" element={<ConsumersPage />} />
        <Route path="wip">
          <Route path="gis" element={<RootProtectedRoute><GISPage /></RootProtectedRoute>} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
